export default __webpack_public_path__ + "static/media/mr-mrs.97b003b5.jpg";